import { render, staticRenderFns } from "./SegmentsSetupLayout.vue?vue&type=template&id=04a71e6e&scoped=true&"
import script from "./SegmentsSetupLayout.vue?vue&type=script&lang=js&"
export * from "./SegmentsSetupLayout.vue?vue&type=script&lang=js&"
import style0 from "./SegmentsSetupLayout.vue?vue&type=style&index=0&id=04a71e6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a71e6e",
  null
  
)

export default component.exports